import { NoddiIconName } from 'noddi-ui-common';

/**
 * Option interface for MultiSelect component
 */
export interface MultiSelectOption {
  /** The text to display for the option. */
  label: string;
  /** The unique value associated with the option. */
  value: string | number;
  /** Optional icon component to display alongside the option. */
  icon?: NoddiIconName;
  /** Optional image URL to display alongside the option. */
  imageUrl?: string;
  /** Whether this option is disabled */
  disabled?: boolean;
  /** Custom styling for the option */
  style?: {
    /** Custom badge color */
    badgeColor?: string;
    /** Custom icon color */
    iconColor?: string;
    /** Gradient background for badge */
    gradient?: string;
  };
}

/**
 * Group interface for organizing options
 */
export interface MultiSelectGroup {
  /** Group heading */
  heading: string;
  /** Options in this group */
  options: MultiSelectOption[];
}

export const isMultiSelectGroupedOptions = (
  opts: MultiSelectOption[] | MultiSelectGroup[]
): opts is MultiSelectGroup[] => opts.length > 0 && 'heading' in opts[0]! && Array.isArray(opts[0]?.options);

export const flattenMultiSelectOptions = (opts: MultiSelectOption[] | MultiSelectGroup[] = []): MultiSelectOption[] =>
  isMultiSelectGroupedOptions(opts) ? opts.flatMap((group) => group.options) : opts;
